import { useState } from 'react';
import { Link } from 'react-router-dom';
import { blogPosts, blogCategories } from '../data/blogData';
import { FaClock, FaUser, FaTag } from 'react-icons/fa';
import './Blog.css';

const Blog = () => {
  const [selectedCategory, setSelectedCategory] = useState('all');

  const filteredPosts = selectedCategory === 'all' 
    ? blogPosts 
    : blogPosts.filter(post => post.category.toLowerCase().replace(/\s+/g, '-') === selectedCategory);

  return (
    <div className="blog-page">
      <div className="page-header">
        <div className="container">
          <h1>Our Blog</h1>
          <p>Read articles about Quran, Islam, and spiritual growth</p>
        </div>
      </div>

      <section className="section">
        <div className="container">
          <div className="blog-categories">
            {blogCategories.map(category => (
              <button
                key={category.slug}
                className={`category-btn ${selectedCategory === category.slug ? 'active' : ''}`}
                onClick={() => setSelectedCategory(category.slug)}
              >
                {category.name} ({category.count})
              </button>
            ))}
          </div>

          <div className="blog-grid">
            {filteredPosts.map(post => (
              <article key={post.id} className="blog-card">
                <div className="blog-image">
                  <div className="image-placeholder">
                    <FaTag />
                  </div>
                  <span className="blog-category">{post.category}</span>
                </div>
                
                <div className="blog-content">
                  <h3>
                    <Link to={`/blog/${post.slug}`}>{post.title}</Link>
                  </h3>
                  
                  <div className="blog-meta">
                    <span className="meta-item">
                      <FaUser /> {post.author}
                    </span>
                    <span className="meta-item">
                      <FaClock /> {post.readTime}
                    </span>
                  </div>

                  <p className="blog-excerpt">{post.excerpt}</p>

                  <div className="blog-tags">
                    {post.tags.slice(0, 3).map((tag, index) => (
                      <span key={index} className="tag">{tag}</span>
                    ))}
                  </div>

                  <Link to={`/blog/${post.slug}`} className="read-more">
                    Read More →
                  </Link>
                </div>
              </article>
            ))}
          </div>

          {filteredPosts.length === 0 && (
            <div className="no-posts">
              <p>No posts found in this category.</p>
            </div>
          )}
        </div>
      </section>
    </div>
  );
};

export default Blog;
